<template>
	<modal
		class="user-service-fee-modal"
		size="medium"
		@close="close"
	>
		<template slot="header">
			<h3>Service Fee</h3>
		</template>
		<template slot="body">
			<div>
				<div v-if="isFetching" class="is-loading mb-4"></div>
				<div v-else>
					<div class="form-group">
						<label for="service-fee-type">
							<b class="">Fee Type</b>
						</label>
						<select
							id="service-fee-type"
							class="form-control"
							v-model="serviceFeeType"
						>
							<option value="percentage">Percentage</option>
							<option value="fixed">Fixed Amount</option>
						</select>
					</div>
					<div class="form-group">
						<label for="service-fee-value">
							<b>Amount Value <template v-if="serviceFeeType === 'percentage'">(%)</template></b>
						</label>
						<input
							type="number"
							id="service-fee-value"
							class="form-control"
							v-model.number="serviceFeeValue"
						/>
					</div>
				</div>
			</div>
		</template>
		<template slot="footer">
			<!-- Close -->
			<button type="button" class="btn btn-light" @click="close">
				<span>{{ $t('Close') }}</span>
			</button>
			<!-- Update -->
			<button
				class="btn btn-primary"
				:class="{ 'is-loading': isUpdating }"
				@click="update"
			>
				<span>{{ $t('Update') }}</span>
			</button>
		</template>
	</modal>
</template>

<script>
// import user from '@/api/user';
import Modal from '@/components/Modal.vue';
// import {
// 	getAxiosErrorMessage,
// } from '@/lib/helper';
import {
	getDetailUserFeeConfig,
	setConfig,
} from '@/api/user-fee';

export default {
	name: 'ModalUserServiceFee',
	components: {
		Modal,
	},
	props: {
		user: {
			default: null,
		},
	},
	data() {
		return {
			isUpdating: false,
			isFetching: false,
			serviceFeeType: 'fixed',
			serviceFeeValue: 1000,
			serviceFee: {
				type: 'fixed',
				value: 1000,
			},
		};
	},
	watch: {
		user: {
			handler() {
				if (this.user) this.fetchUserFeeDetail();
			},
			immediate: true,
		},
	},
	created() {
	},
	methods: {
		close() {
			this.$emit('close');
		},
		update() {
			this.updateServiceFee();
		},
		fetchUserFeeDetail() {
			try {
				const userId = this.user._id ?? '';
				if (!userId) return;
				this.isFetching = true;
				const callback = (response) => {
					const responseData = response.data;
					const type = responseData?.type || 'fixed';
					const value = responseData?.value || 1000;
					this.serviceFeeType = type;
					this.serviceFeeValue = value;
					this.isFetching = false;
				};

				const errorCallback = (err) => {
					this.isFetching = false;
					console.log('err: ', err);
				};

				getDetailUserFeeConfig(userId, callback, errorCallback);
			} catch (error) {
				this.isFetching = false;
				console.log('error: ', error);
			}
		},
		updateServiceFee() {
			try {
				this.isUpdating = true;
				const userId = this.user._id ?? '';
				if (!userId) return;
				const params = {
					user_id: userId,
					type: this.serviceFeeType,
					value: this.serviceFeeValue,
				};
				const callback = () => {
					this.$emit('update', params);
					this.isUpdating = false;
					this.$notify({
						group: 'app',
						type: 'success',
						text: 'Service fee updated successfully',
					});
					this.close();
				};
				const errorCallback = (err) => {
					this.isUpdating = false;
					console.log('err: ', err);
				};
				setConfig(params, callback, errorCallback);
			} catch (error) {
				this.isUpdating = false;
				console.log('error: ', error);
			}
		},
	},
	computed: {

	},
};
</script>
